import { config } from '@react-spring/web'

const gentleFigma = {
  ...config.gentle,
  mass: 1,
  damping: 15,
  tension: 100,
} as const

export const clampedGentleFigma = {
  ...gentleFigma,
  clamp: true,
} as const
